import { Button } from "antd";
import { useExport } from "./hooks/useExport";

export const BulkCoupons = () => {
  const { onExportClicked, isLoading } = useExport();

  return (
    <Button
      className="pa-0"
      type="link"
      size="small"
      disabled={isLoading}
      onClick={onExportClicked}
    >
      Bobby's Coupons
    </Button>
  );
};
